import constants from "./academicConstants";
import call from "@/service/http";

export default {
  state: {
    academic: [],
    specializations: [],
    grades: [],
    qualificationCodes: [],
    professionalCodes: [],
    academicCodes: [],
    certificationCodes: [],
    singleQualification: {},
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.value;
    },

    SET_ACADEMIC_ALERT: (state, payload) => {
      state.acadmicAlert = payload || {
        status: "",
        message: "",
      };
    },
  },

  getters: {
    academicGetters: (state) => (val) => state[val],
  },
  actions: {
    getAcademic: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.academic)
        .then((res) => {
          commit("MUTATE", { state: "academic", value: res.data.data });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    getSpecializations: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.specializations)
        .then((res) => {
          commit("MUTATE", { state: "specializations", value: res.data.data });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    getQualificationCodes: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.qualificationCodes)
        .then((res) => {
          commit("MUTATE", {
            state: "qualificationCodes",
            value: res.data.data,
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    getProfessionalCodes: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.professionalCodes)
        .then((res) => {
          commit("MUTATE", {
            state: "professionalCodes",
            value: res.data.data,
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    getAcademicCodes: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.academicCodes)
        .then((res) => {
          commit("MUTATE", {
            state: "academicCodes",
            value: res.data.data,
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    saveAcademic: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      call("post", constants.academic, data)
        .then(() => {
          /* re-fetch certifications */
          dispatch("getAcademic");
          Event.$emit("academicClose");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    removeAcademic: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("post", constants.remove, payload)
        .then(() => {
          dispatch("getAcademic");
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    updateAcademic: ({ dispatch, commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      call("patch", constants.academic, payload)
        .then(() => {
          dispatch("getAcademic");
          Event.$emit("ApiSuccess", "Successfully Updated");
          Event.$emit("academicClose");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
    getOneQualification({ commit }, payload) {
      commit("SET_LOADING", true, { root: true });
      call("get", constants.SINGLE(payload))
        .then((res) => {
          commit("MUTATE", {
            state: "singleQualification",
            value: res.data.data[0],
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
  },
};
